import { createRoot } from "react-dom/client"; // Import from react-dom/client for React 18
import domReady from "@wordpress/dom-ready";
import NavMenu from '@components/NavMenu'
import App from "./App";
import "./styles.css";

domReady(() => {
	const rootElement = document.getElementById("uae-settings-app");
	if (rootElement) {
		const root = createRoot(rootElement); // Use createRoot() for React 18
		root.render(<App />);
	}
	
	if( uaelSettingsData.is_lite_active ) {
		if ( window.location.href === uaelSettingsData.header_footer_builder || "yes" === uaelSettingsData.is_hfe_post ) {
			const navMenuElement = document.getElementById("hfe-admin-top-bar-root");
			if (navMenuElement) {
				const newDiv = document.createElement("div");
				newDiv.id = "uae-settings-app";
				navMenuElement.appendChild(newDiv);
		
				const navMenuRoot = createRoot(newDiv);
				navMenuRoot.render(<NavMenu />);
			}
		}
	}
});
